// import Swiper JS
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const processData = {
  _id: 1,
  _lastID: 1,
};

const swiperStoreInformation = new Swiper(".swiper__serviceProcess", {
  modules: [Navigation],
  slidesPerView: 1,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  on: {
    slideChangeTransitionStart: function (e) {
      processData.id = e.realIndex + 1;
    },
  },
});

processInit();

/**
 * 服務流程初始化
 */
function processInit() {
  // svg 添加漸進動畫
  const svgPath = document.querySelectorAll("svg path");
  svgPath.forEach((item) => {
    item.classList.add("transition-all", "duration-300");
  });

  // 輪播圖目前頁面 id 監控
  Object.defineProperties(processData, {
    id: {
      get: function () {
        return processData._id;
      },
      set: function (value) {
        processData.lastID = processData._id;
        processData._id = value;
        processHandler();
      },
    },
    lastID: {
      value: 1,
      writable: true,
    },
  });

  processIndexChange();
}

/**
 * 服務流程流程顏色變換
 */
function processHandler() {
  // 輪播圖向前移動
  if (processData.id > processData.lastID) {
    processForward();
  }
  // 輪播圖向後移動
  else {
    processBackwards();
  }
}
/**
 * 向前移動變換顏色
 */
function processForward() {
  const numArr = [];

  for (let i = 2; i <= processData.id; i++) {
    numArr.push(i);
  }
  numArr.forEach((idx) => {
    const processCircle = document.querySelector(
      `[data-id="process-circle-${idx}"]`
    );
    const processLine = document.querySelector(
      `[data-id="process-line-${idx - 1}"]`
    );
    const processSvgPath = document.querySelectorAll(
      `[data-id="process-svg-${idx}"] svg path`
    );

    processCircle.classList.add("bg-white", "border-primary");
    processCircle.classList.remove("border-gray-5", "bg-gray-6");

    processSvgPath.forEach((item) => {
      item.classList.add("fill-primary");
    });

    processLine.classList.add("bg-primary");
    processLine.classList.remove("bg-gray-5");
  });
}
/**
 * 向後移動變換顏色
 */
function processBackwards() {
  const numArr = [];
  for (let i = 6; i > processData.id; i--) {
    numArr.push(i);
  }
  numArr.forEach((idx) => {
    const processCircle = document.querySelector(
      `[data-id="process-circle-${idx}"]`
    );
    const processLine = document.querySelector(
      `[data-id="process-line-${idx - 1}"]`
    );
    const processSvgPath = document.querySelectorAll(
      `[data-id="process-svg-${idx}"] svg path`
    );

    processCircle.classList.remove("bg-white", "border-primary");
    processCircle.classList.add("border-gray-5", "bg-gray-6");

    processLine.classList.remove("bg-primary");
    processLine.classList.add("bg-gray-5");

    processSvgPath.forEach((item) => {
      item.classList.remove("fill-primary");
    });
  });
}

/**
 * 移動到指定索引服務流程流程
 */
function processIndexChange() {
  const serviceProcessBtn = document.querySelectorAll(
    `[data-type="service_process_btn"]`
  );
  Array.from(serviceProcessBtn).forEach((btn, idx) => {
    btn.addEventListener("click", () => {
      swiperStoreInformation.slideTo(idx);
    });
  });
}
